module.exports = __webpack_public_path__ + "img/b5.537ceb7d.jpg";